module.exports = __webpack_public_path__ + "assets/img/c83725d4f40d53247f4894e205308889.png";